// src/pages/Contact.js
import React from 'react';

function Contact() {
  return (
    <div>
      <h2>Contactez-nous</h2>
      <p>Envoyez-nous un message pour plus d'informations.</p>
    </div>
  );
}

export default Contact;
